import firebase from 'firebase';
import firebaseui from 'firebaseui';
import $ from 'jquery';
import _ from 'lodash';

import '../node_modules/firebaseui/dist/firebaseui.css';
import './_styles/bootstrap/css/bootstrap.superhero.css';
import './_styles/spinners/spinkit.less';
import './_components/modal/modal.less';
import './app.styles.less';

import appEvts from './_services/app-events.service.js';
import utils from './_utils/utils.js';
import Router from './_components/router/router.js';

import SectionsBarView from './sections-bar/sections-bar.view.js';
import AccountBox from './account-box/account-box.view.js';
import AdminSection from './admin-section/admin-section.view.js';
import HomeSection from './home-section/home-section.view.js';
import NormativeSection from './normative-section/normative-section.view.js';
import NewsSection from './news-section/news-section.view.js';
import HistorySection from './history-section/history-section.view.js';



class TransformaPingPongLeague {

	constructor () {
		this.initSectionsMap();

		this.initializeFirebase();
		this.initializeFirebaseUI();
		this.setUIElements();
		this.initEvents();
		this.initApp();
	}

	initSectionsMap() {

		this.sections = {};

		this.sectionsMap = {
			admin: AdminSection,
			home: HomeSection,
			normative: NormativeSection,
			news: NewsSection,
			historic: HistorySection
		}
	}

	initializeFirebase() {
		// Initialize Firebase
		let config = {
			apiKey: "AIzaSyDQb-z-rr9Wzp28lzOgc7h2E8z-Q6IcFRo",
			authDomain: "transforma-pingpong-league.firebaseapp.com",
			databaseURL: "https://transforma-pingpong-league.firebaseio.com",
			storageBucket: "transforma-pingpong-league.appspot.com",
			messagingSenderId: "16124613606"
		};

		firebase.initializeApp(config);
	}

	initializeFirebaseUI() {
		// Initialize FirebaseUI Auth using Firebase.
		this.firebaseUI = new firebaseui.auth.AuthUI(firebase.auth());
	}

	setUIElements() {
		this.ui = {
			accountBoxContainer: $('#account-box-container'),
			sectionsBarContainer: $('#sections-bar-container'),
			appSectionsContainer: $('#app-sections-container')
		};
	}

	initEvents() {
		appEvts.on('goto:section:admin', () => {
			this.showSection('admin');
		});
		appEvts.on('goto:section:home', () => {
			this.showSection('home');
		});
		appEvts.on('goto:section:normative', () => {
			this.showSection('normative');
		});
		appEvts.on('goto:section:news', () => {
			this.showSection('news');
		});
		appEvts.on('goto:section:historic', () => {
			this.showSection('historic')
		});
	}

	showSection(sectionName) {
		window.console.log('Show section: ', sectionName);
		if (!this.sectionsMap[sectionName]) {
			sectionName = 'home';
		}

		if (!this.sections[sectionName]) {
			this.sections[sectionName] = new this.sectionsMap[sectionName]();
		}
		if (this.currentSection) {
			this.currentSection.detach();
		}

		this.sections[sectionName].show(this.ui.appSectionsContainer);
		this.currentSection = this.sections[sectionName];
	}

	initApp() {

		this.sectionsBar = new SectionsBarView();
		this.sectionsBar.show(this.ui.sectionsBarContainer);

		this.accountBox = new AccountBox(null, {
			firebaseUI: this.firebaseUI
		});
		this.accountBox.show(this.ui.accountBoxContainer);

		this.appQueryParams = utils.getURLQueryParams();

		let initialSection = this.appQueryParams.section || 'home';
		this.showSection(initialSection);

/*		this.router = new Router().state('root', {
				path: '/',
				resolve: this.initMainView.bind(this)
			})
			.state('news', {
				path: '/news/:newId',
				resolve: this.initSingleNewView.bind(this)
			});*/

	}


}


window.onload = function() {
	'use strict';

	let tLeague = new TransformaPingPongLeague();

};



export default TransformaPingPongLeague;



// WEBPACK FOOTER //
// ./C:/Users/juanb/Dev/transforma-ping-pong-league/src/app.js